import { render, staticRenderFns } from "./mainInformation.vue?vue&type=template&id=cb34a338&scoped=true&"
import script from "./mainInformation.vue?vue&type=script&lang=js&"
export * from "./mainInformation.vue?vue&type=script&lang=js&"
import style0 from "./mainInformation.vue?vue&type=style&index=0&id=cb34a338&scoped=true&lang=css&"
import style1 from "./mainInformation.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb34a338",
  null
  
)

export default component.exports